export default __webpack_public_path__ + "static/media/197374.2d19fed4.svg";